import React, { memo } from 'react';

import HighlightColumn from '../Table/Decorator/HighlightColumn';
import Loading from '../../General/Loading';
import Table from '../Table/Table';
import { ExportPdf } from '../Pdf/ExportPdf';

import { FIXED_PERIOD_FILTERS } from '../../../Constants/Interest/Filter';
import InterestUri from '../../../Enum/InterestUri';

import getHighlightedColumnNumber from '../../../Reducer/GetHighlightedColumnNumber';
import useGetSort from '../../../Hook/Interest/UseGetSort';
import useIsFilterLoading from '../../../Hook/Interest/UseIsFilterLoading';
import useGetInterestByFixedPeriod from '../../../Hook/Interest/FetchTableData/UseGetInterestByFixedPeriod';
import useGetFilteredValues from '../../../Hook/Interest/UseGetFilteredValues';

const InterestFixedPeriodTable: React.FC = () => {
    const {
        constructionType,
        energyLabel,
        fixedPeriods,
        loanForm,
        nhg,
        riskCategory,
        clientType,
        account,
    } = useGetFilteredValues();
    const isFilterLoading = useIsFilterLoading();
    const currentSort = useGetSort(InterestUri.FixedPeriod);
    const { error, data, headers, loading } = useGetInterestByFixedPeriod(
        constructionType,
        energyLabel,
        loanForm,
        nhg,
        fixedPeriods,
        riskCategory,
        clientType,
        account,
    );

    if (fixedPeriods.length === 0) {
        return <p className="no-results">Selecteer één of meerdere rentevastperiodes om te beginnen.</p>;
    }

    if (isFilterLoading || loading) {
        return <Loading />;
    }

    if (error || !data.length || !headers.length) {
        return <p className="no-results">Geen resultaten gevonden, pas uw filters aan.</p>;
    }

    const highlightedColumnNO = getHighlightedColumnNumber(currentSort.prop, headers);
    return (
        <>
            {highlightedColumnNO > 0 && <HighlightColumn column={highlightedColumnNO} />}
            <ExportPdf
                filterSettings={FIXED_PERIOD_FILTERS}
                headers={headers}
                rows={data}
                section={InterestUri.FixedPeriod}
                sort={currentSort}
            />
            <Table
                className="interest-fixed-period"
                data={data}
                headers={headers}
                section={InterestUri.FixedPeriod}
                sort={currentSort}
            />
        </>
    );
};

export default memo(InterestFixedPeriodTable);
